<template>
  <div>
    <el-table :data="users" class="w100" stripe v-loading="loading">
      <el-table-column label="Name">
        <template slot-scope="props">
          {{ props.row.user && props.row.user.first_name }} {{ props.row.user && props.row.user.surname }}
        </template>
      </el-table-column>

      <el-table-column label="Email">
        <template slot-scope="props">
          {{ props.row.user && props.row.user.email }}
        </template>
      </el-table-column>

      <el-table-column label="Company Name" prop="company_name" />
      <el-table-column label="Country" prop="country" />
      <el-table-column label="Catalogue Size" prop="catalogue_size" />
      <el-table-column label="Revenue" prop="revenue" />
      <el-table-column label="Digital Audio Workstation" prop="digital_audio_workstation" />
      <el-table-column label="Ownership Verification">
        <template slot-scope="props">
          {{ props.row.ownership_verification ? 'Yes' : 'No' }}
        </template>
      </el-table-column>
      <el-table-column label="Social Media" prop="social_media_links" />

      <el-table-column label="CID Enabled">
        <template slot-scope="props">
          {{ props.row.cid_enabled ? 'Yes' : 'No' }}
        </template>
      </el-table-column>
      <el-table-column label="About Us" prop="about_us" />

      <el-table-column label="Approved">
        <template slot-scope="props">
          <el-tag :type="props.row.approved ? 'success' : 'warning'">
            {{ props.row.approved ? 'Approved' : 'Pending' }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column label="Submitted At">
        <template slot-scope="props">
          {{ moment(props.row.created_at).format('DD MMM YYYY') }}
        </template>
      </el-table-column>
      <el-table-column label="Actions" align="center" width="200">
        <template slot-scope="props">
          <div class="action-buttons">
            <el-button
              v-if="!props.row.approved"
              type="success"
              size="mini"
              @click="handleApproveSurvey(props.row)"
            >
              Approve
            </el-button>

            <div class="contract-buttons" v-if="!props.row.approved">
              <el-tooltip
                content="CID Contract"
                placement="top"
                v-if="props.row.user && hasCidContract(props.row.user.contracts)"
              >
                <el-button
                  type="info"
                  icon="el-icon-document"
                  size="mini"
                  @click="getCidReport(props.row.user)"
                  class="contract-btn"
                />
              </el-tooltip>

              <el-tooltip
                content="Distro Contract"
                placement="top"
                v-if="props.row.user && hasDistroContract(props.row.user.contracts)"
              >
                <el-button
                  type="info"
                  icon="el-icon-document"
                  size="mini"
                  @click="getDistroReport(props.row.user)"
                  class="contract-btn"
                />
              </el-tooltip>
            </div>

            <span v-else>—</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<style scoped>
.action-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.contract-buttons {
  display: flex;
  gap: 6px;
  margin-top: 4px;
}

.contract-btn {
  border-radius: 6px;
}
</style>
<script>
import moment from "moment";
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: "CIDSubmissionsTab",
  data() {
    return { moment };
  },
  computed: {
    ...mapState('cidUsers', ['users', 'loading'])
  },
  created() {
    this.fetchUsers();
  },
  methods: {
    ...mapActions('cidUsers', ['fetchUsers', 'approveSurvey']),
    ...mapActions('user', ['getCidContract', 'getDistroContract']),

    async handleApproveSurvey(survey) {
      try {
        await this.approveSurvey(survey.id);
        survey.approved = true;
        this.$message.success("Survey approved successfully");
      } catch (e) {
        console.error(e);
        this.$message.error("Failed to approve survey");
      }
    },
    cid_service(services = []) {
      return Array.isArray(services) && services.some(f => +f.service_id === 1);
    },

    hasCidContract(contracts = []) {
      return Array.isArray(contracts) && contracts.some(c => c.contract_type_id === 2);
    },

    getCidReport(user) {
      this.getCidContract(user.id);
    },

    distro_service(services = []) {
      return Array.isArray(services) && services.some(f => +f.service_id === 3);
    },

    hasDistroContract(contracts = []) {
      return Array.isArray(contracts) && contracts.some(c => c.contract_type_id === 3);
    },

    getDistroReport(user) {
      this.getDistroContract(user.id);
    }
  },
};
</script>